import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../../backend/firebaseConfig";

const STAFF_PATH = ["Authorized Members", "Staff", "Data"];

const humaniseEmail = (email) =>
  String(email || "")
    .split("@")[0]
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");

const getDisplayName = (data, email) => {
  const combinedName = [data.firstName, data.lastName].filter(Boolean).join(" ");
  return data.displayName || data.name || data.fullName || combinedName || humaniseEmail(email);
};

export const normaliseJobDescription = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const getStaffForStatus = (staff, status) => {
  const target = normaliseJobDescription(status);
  if (!target) return [];

  return staff.filter((person) =>
    person.jobDescriptions.some(
      (jobDescription) => normaliseJobDescription(jobDescription) === target,
    ),
  );
};

export const getRoseFallback = (staff) =>
  staff.find((person) => {
    const name = normaliseJobDescription(person.name);
    const emailName = normaliseJobDescription(String(person.email || "").split("@")[0]);
    return name === "rose" || name.startsWith("rose ") || emailName === "rose" || emailName.startsWith("rose ");
  });

export const getAssigneeForStatus = (staff, status) => {
  if (!normaliseJobDescription(status)) return undefined;
  return getStaffForStatus(staff, status)[0] || getRoseFallback(staff);
};

export const filterStaffForStatuses = (staff, statuses) => {
  const relevantJobs = new Set(
    statuses.map(normaliseJobDescription).filter(Boolean),
  );

  const relevantStaff = staff.filter((person) =>
    person.jobDescriptions.some((jobDescription) =>
      relevantJobs.has(normaliseJobDescription(jobDescription)),
    ),
  );

  const rose = getRoseFallback(staff);
  return rose && !relevantStaff.some((person) => person.id === rose.id)
    ? [...relevantStaff, rose].sort((left, right) => left.name.localeCompare(right.name))
    : relevantStaff;
};

export const subscribeStaffJobDescriptions = (callback, onError) =>
  onSnapshot(
    collection(db, ...STAFF_PATH),
    (snapshot) => {
      const staff = snapshot.docs
        .map((staffDoc) => {
          const data = staffDoc.data() || {};
          const email = String(data.email || staffDoc.id || "").trim().toLowerCase();
          const displayName = getDisplayName(data, email);

          return {
            id: displayName,
            name: displayName,
            email,
            jobDescriptions: Array.isArray(data.jobDescriptions)
              ? data.jobDescriptions.filter(Boolean)
              : [],
          };
        })
        .filter((person) => person.name)
        .sort((left, right) => left.name.localeCompare(right.name));

      callback(staff);
    },
    onError,
  );
